export function UserEditIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 20 20"
      className={className}
    >
      <path
        d="M7.49984 12.9167H6.24984C5.08687 12.9167 4.50538 12.9167 4.03222 13.0602C2.96688 13.3834 2.1332 14.217 1.81004 15.2824C1.6665 15.7555 1.6665 16.337 1.6665 17.5M12.0832 6.25C12.0832 8.32107 10.4042 10 8.33317 10C6.2621 10 4.58317 8.32107 4.58317 6.25C4.58317 4.17893 6.2621 2.5 8.33317 2.5C10.4042 2.5 12.0832 4.17893 12.0832 6.25ZM9.1665 17.5L11.751 16.7616C11.8747 16.7262 11.9366 16.7085 11.9943 16.682C12.0456 16.6585 12.0943 16.6298 12.1398 16.5965C12.191 16.5589 12.2365 16.5134 12.3275 16.4224L17.7082 11.0417C18.2835 10.4664 18.2835 9.53362 17.7082 8.95831C17.1329 8.38302 16.2001 8.38303 15.6249 8.95833L10.2441 14.339C10.1531 14.43 10.1076 14.4756 10.07 14.5267C10.0367 14.5722 10.008 14.6209 9.98446 14.6722C9.95796 14.7299 9.94028 14.7918 9.90492 14.9155L9.1665 17.5Z"
        stroke="#2E2E2F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
